export default __webpack_public_path__ + "static/media/img2.87c2f1bc.jpg";